/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {transformJsonProperty} from '../../components/util/adn-http-resource-transforms';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceListParams,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

const transform = transformJsonProperty('data');

export interface TargetingTemplateModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class TargetingTemplateApiService extends SignalAdminResourceApiBase<TargetingTemplateModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'targetingtemplates');
  }

  override list(params: SignalAdminResourceListParams): Observable<SignalAdminResourcePage<TargetingTemplateModel>> {
    return super.list(params).pipe(map((page) => ({
      ...page,
      results: (page.results || []).map((model) => transform.transformResponse(model))
    })));
  }

  override get(id: string): Observable<TargetingTemplateModel> {
    return super.get(id).pipe(map((model) => transform.transformResponse(model)));
  }

  override save(model: TargetingTemplateModel): Observable<TargetingTemplateModel> {
    return super.save(transform.transformRequest(model)).pipe(
      map((saved) => transform.transformResponse(saved))
    );
  }
}
